import React, { useContext, cloneElement, forwardRef, createContext, } from 'react';
const AccordionContext = createContext(undefined);
const Accordion = forwardRef(function Accordion({ testId = 'store-accordion', indices, onChange, children, ...otherProps }, ref) {
    const childrenWithIndex = React.Children.map(children, (child, index) => cloneElement(child, { index: child.props.index ?? index }));
    const context = {
        indices: new Set(indices),
        onChange,
        numberOfItems: childrenWithIndex.length,
    };
    return (React.createElement(AccordionContext.Provider, { value: context },
        React.createElement("div", Object.assign({ ref: ref, "data-store-accordion": true, "data-testid": testId, role: "region" }, otherProps), childrenWithIndex)));
});
export function useAccordion() {
    const context = useContext(AccordionContext);
    if (context === undefined) {
        throw new Error('Do not use Accordion components outside the Accordion context.');
    }
    return context;
}
export default Accordion;
//# sourceMappingURL=Accordion.js.map